module.exports = __webpack_public_path__ + "img/sFruitTyc_193x205.328ce0af.png";